// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1dkja","search":"Settings_search__1FR-t","filter":"Settings_filter__2PqDl"};